


































import { apiOrderOrderInvoiceInfo } from '@/api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent, useApi, useQuery } from '@/hooks'
import { Track } from '@/utils'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '查看发票',
        }))
      }

      query = useQuery<{
        /** 订单编号 */
        orderNo: string
      }>()

      pageData = useApi(() =>
        apiOrderOrderInvoiceInfo({
          orderNo: this.query.orderNo,
        }),
      )

      // 点击联系客服
      handleContactClick = () => {
        dcb.makeCustomerServicePhoneCall()
      }

      // 点击保存发票图片
      handleSaveClick = () => {
        dcb.saveImageToPhotosAlbum({
          filePath: this.pageData.data.invoiceUrl!,
        })
      }
    },
)
